module.exports = __webpack_public_path__ + "static/media/fx.0833ce35.wav";